export function animateResumeEntries(resumeEntries) {
    const resumeEntriesArray = Array.from(resumeEntries);

    resumeEntriesArray.sort(function(a, b) {
        const aRect = a.getBoundingClientRect();
        const bRect = b.getBoundingClientRect();
        return aRect.top - bRect.top;
    });

    for (let i = 0; i < resumeEntriesArray.length - 1; i++) {
        let entry = resumeEntriesArray[i];
        let entryBoundingBox = entry.getBoundingClientRect();
        let nextEntry = resumeEntriesArray[i + 1];

        if (entryBoundingBox.top <= window.innerHeight) {
            entry.classList.add("active");
            entry.classList.remove("hidden");
        }

        if (entryBoundingBox.bottom + 100 <= window.innerHeight) {
            nextEntry.classList.add("active");
            nextEntry.classList.remove("hidden");
        }
    }
}

// Wire mouse-tracked shine effect: updates --mx/--my CSS variables on cards
export function attachResumeMouseTracking(resumeEntries) {
    const handlers = [];

    resumeEntries.forEach((entry) => {
        const onMove = (e) => {
            const rect = entry.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            entry.style.setProperty('--mx', `${x}%`);
            entry.style.setProperty('--my', `${y}%`);
        };
        entry.addEventListener('mousemove', onMove);
        handlers.push({ entry, onMove });
    });

    return () => {
        handlers.forEach(({ entry, onMove }) => {
            entry.removeEventListener('mousemove', onMove);
        });
    };
}
